import {Summary, getServerSideProps as getSummaryServerSideProps} from 'src/Views/MarketResearch/Financials/Summary';

export default function SummaryPage({instrumentData}) {
    return <Summary instrumentData={instrumentData} />
}

export async function getServerSideProps(context) {
    return getSummaryServerSideProps(context);
}
